module.exports = __webpack_public_path__ + "img/35.2.TN.f92a7ee6.png";